export interface AuthAppConfig {
  key: string;
  name: string;
  domain: string;
}

export const APPROVED_APPS: Record<string, AuthAppConfig> = {
  cc: {
    key: 'cc',
    name: 'Compassion Causes',
    domain: 'compassioncauses.com',
  },
  mc: {
    key: 'mc',
    name: 'My Compassion',
    domain: process.env.BASE_URL_MY || 'my.local.compassion.com:3002',
  },
};
